import { useMediaQuery, Grid, Typography, colors } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';

import PropTypes from 'prop-types';

import { SectionHeader, IconAlternate } from '@/src/components/molecules';
import { CardBase, DescriptionListIcon } from '@/src/components/organisms';

const Advantages = props => {
  const { data, className, ...rest } = props;

  const theme = useTheme();
  const isLg = useMediaQuery(theme.breakpoints.up('lg'), { defaultMatches: true });

  return (
    <div className={className} data-aos="fade-up" {...rest}>
      <SectionHeader
        title={
          <span>
            Levamos a sério a{' '}
            <Typography color="secondary" variant="inherit" component="span">
              segurança e privacidade
            </Typography>{' '}
            dos nossos usuários
          </span>
        }
        subtitle="Seguimos as melhores práticas adotadas pelo mercado no tratamento de dados e no nível de privacidade que oferecemos aos nossos usuários."
        fadeUp
      />
      <Grid container spacing={isLg ? 10 : 2}>
        {data.map((item, index) => (
          <Grid
            key={index.toString()}
            item
            container
            alignItems="center"
            direction="column"
            xs={12}
            sm={6}
            data-aos="fade-up">
            <CardBase liftUp variant="outlined">
              <DescriptionListIcon
                title={item.title}
                subtitle={item.description}
                icon={<IconAlternate fontIconClass={item.icon} size="medium" color={colors.blue} />}
              />
            </CardBase>
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

Advantages.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
  /**
   * data to be rendered
   */
  data: PropTypes.array.isRequired,
};

export default Advantages;
